import { Activity, ArrowDown, ArrowUp, BarChart3, Bot, Building2, ClipboardList, Clock, CreditCard, FileText, Home, Inbox, List, Receipt, Send, Settings, Users, type LucideIcon } from 'lucide-react';

export interface NavItem { label: string; path: string; page: string; icon: LucideIcon }

export function reviewBadgeTone(count: number): 'amber' | 'red' | null {
  if (count < 1) return null;
  return count > 5 ? 'red' : 'amber';
}
export const NAV: { title: string; items: NavItem[] }[] = [
  { title: 'Overview', items: [
    { label: 'Dashboard', path: '/', page: 'finance_home', icon: Home },
    { label: 'Review', path: '/review', page: 'finance_home', icon: ClipboardList },
  ] },
  { title: 'Receivable', items: [
    { label: 'Reporting customers', path: '/reporting-customers', page: 'engagements', icon: Building2 },
    { label: 'Billing entities', path: '/customers', page: 'engagements', icon: Building2 },
    { label: 'Engagements', path: '/engagements', page: 'engagements', icon: ClipboardList },
    { label: 'Charge lines', path: '/charge-lines', page: 'charge_lines', icon: List },
    { label: 'Customer orders', path: '/purchase-orders', page: 'purchase_orders', icon: FileText },
    { label: 'Invoices', path: '/invoices', page: 'invoices', icon: FileText },
    { label: 'Invoice templates', path: '/invoice-templates', page: 'invoices', icon: FileText },
    { label: 'Sales offers', path: '/quotations', page: 'quotations', icon: Send },
    { label: 'Payments in', path: '/payments-in', page: 'payments', icon: ArrowDown },
  ] },
  { title: 'Payable', items: [
    { label: 'Vendors', path: '/vendors', page: 'vendors', icon: Building2 },
    { label: 'Purchase orders', path: '/supplier-purchase-orders', page: 'purchase_orders', icon: ClipboardList },
    { label: 'Bills', path: '/bills', page: 'bills', icon: Receipt },
    { label: 'Expenses', path: '/expenses', page: 'expenses', icon: CreditCard },
    { label: 'People', path: '/people', page: 'people', icon: Users },
    { label: 'Payments out', path: '/payments-out', page: 'payments', icon: ArrowUp },
    { label: 'Budgets', path: '/budgets', page: 'budgets', icon: BarChart3 },
  ] },
  { title: 'Operate', items: [
    { label: 'Inbox', path: '/inbox', page: 'inbox', icon: Inbox },
    { label: 'Reports', path: '/?report=receivable', page: 'reports', icon: BarChart3 },
    { label: 'Jobs', path: '/jobs', page: 'jobs', icon: Clock },
    { label: 'Processes', path: '/processes', page: 'jobs', icon: Activity },
    { label: 'Agents', path: '/agents', page: 'ai_config', icon: Bot },
    { label: 'Settings', path: '/settings', page: 'integrations', icon: Settings },
  ] },
];

const TITLES: Record<string, string> = {
  '/': 'Dashboard', '/review': 'Review', '/reporting-customers': 'Reporting customers', '/customers': 'Billing entities', '/engagements': 'Engagements', '/charge-lines': 'Charge lines',
  '/purchase-orders': 'Customer orders', '/supplier-purchase-orders': 'Purchase orders', '/invoices': 'Invoices', '/invoice-templates': 'Invoice templates', '/quotations': 'Sales offers',
  '/payments-in': 'Payments in', '/vendors': 'Vendors', '/bills': 'Bills', '/expenses': 'Expenses', '/people': 'People',
  '/payments-out': 'Payments out', '/budgets': 'Budgets', '/inbox': 'Inbox', '/reports': 'Reports', '/jobs': 'Jobs', '/processes': 'Processes', '/chat': 'Collaborate',
  '/agents': 'Agents', '/settings': 'Settings',
};

export function isDocumentPath(url: string): boolean {
  const path = url.split('?')[0];
  if (path.startsWith('/sales-offers/')) return true;
  return /^\/(proposals|quotations|invoices|purchase-orders|supplier-purchase-orders)\/.+/.test(path);
}

export function titleForUrl(url: string): string {
  const path = url.split('?')[0];
  if (TITLES[path]) return TITLES[path];
  if (path.startsWith('/invoices/')) return 'Invoice';
  if (path.startsWith('/invoice-templates/')) return 'Invoice template';
  if (path.startsWith('/quotations/')) return 'Quotation';
  if (path.startsWith('/proposals/')) return 'Proposal';
  if (path.startsWith('/purchase-orders/')) return 'Customer order';
  if (path.startsWith('/supplier-purchase-orders/')) return 'Purchase order';
  if (path.startsWith('/bills/')) return 'Bill';
  return 'Backoffice';
}
